// i18n area 'tasks' — locale de-DE (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.de-DE.meta.json.
import type { enUS } from './tasks'

export const deDE: typeof enUS = {
  macrotasks: {
    title: 'Macrotasks',
    subtitle: 'Zusammengesetzte Operationen — ab dem fehlgeschlagenen Schritt wiederaufnehmbar, oder rücknehmbar',
    colType: 'Typ',
    colTarget: 'Objekt',
    colPhase: 'Phase',
    colSteps: 'Schritte',
    empty: 'Keine Macrotasks',
    detail: 'Details',
    failedAt: 'fehlgeschlagen bei',
    resume: 'Ab dem fehlgeschlagenen Schritt erneut versuchen',
    abort: 'Alles zurücknehmen',
    cancel: 'Abbrechen',
    actionError: 'Die Aktion wurde abgelehnt'
  },
  tasks: {
    title: 'Tasks',
    searchPlaceholder: 'Nach Typ oder Target suchen',
    type: 'Typ',
    target: 'Target',
    phaseLabel: 'Phase',
    progress: 'Fortschritt',
    started: 'Gestartet',
    finished: 'Beendet',
    node: 'Knoten',
    empty: 'Keine Tasks',
    loadError: 'Die Tasks konnten nicht geladen werden — ist das TVirt-Backend erreichbar?',
    limboHint: "Knoten '{node}' seit {time} nicht erreichbar — der Task hält den Write-Lease auf seinem Target, bis der Knoten zurückkehrt oder als ausgeschaltet attestiert wird",
    nodeAttested: 'Knoten als ausgeschaltet attestiert',
    phase: {
      queued: 'In der Warteschlange',
      running: 'Läuft',
      succeeded: 'Abgeschlossen',
      failed: 'Fehlgeschlagen',
      cancelled: 'Abgebrochen',
      'failed-at-step': 'An einem Schritt fehlgeschlagen',
      aborted: 'Zurückgenommen'
    },
    dropdown: {
      tooltip: 'Laufende Tasks',
      title: 'Laufende Tasks',
      empty: 'Keine laufenden Tasks',
      viewAll: 'Alle Tasks anzeigen'
    },
    detail: {
      open: 'Details',
      scope: 'Bereich',
      message: 'Meldung',
      params: 'Parameter',
      result: 'Ergebnis',
      errorTitle: 'Fehler',
      steps: 'Schritte',
      failedAt: 'fehlgeschlagen bei',
      superseded: 'überholt',
      step: 'Schritt',
      parent: 'Übergeordneter Task',
      failedStep: 'Fehlgeschlagener Schritt',
      log: 'Log',
      logEmpty: 'Noch keine Log-Zeilen',
      close: 'Schließen'
    },
    actions: {
      cancel: 'Abbrechen',
      resume: 'Ab dem fehlgeschlagenen Schritt erneut versuchen',
      abort: 'Alles zurücknehmen (Undo der abgeschlossenen Schritte)',
      refused: 'Die Aktion wurde abgelehnt'
    }
  },
  events: {
    loadError: 'Das Journal konnte nicht geladen werden — ist das TVirt-Backend erreichbar?',
    title: 'Ereignisse',
    subtitle: 'Das historische Gedächtnis des Clusters: vollendete Tatsachen, neueste zuerst',
    filterSeverity: 'Schweregrad',
    filterCategory: 'Kategorie',
    filterAll: 'Alle',
    searchLabel: 'Suchen',
    searchPlaceholder: 'Im gesamten Journal suchen',
    subjectFilter: 'Ereignisse von {subject} — alle anzeigen',
    colAt: 'Wann',
    colSeverity: 'Schweregrad',
    colType: 'Typ',
    colSubject: 'Subjekt',
    colActor: 'Wer',
    colNode: 'Node',
    colMessage: 'Meldung',
    empty: 'Keine Ereignisse',
    loadMore: 'Mehr laden',
    actorSystem: 'System',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Ereignis-ID',
    taskCollectedHint: 'Der Task hat eine kürzere Aufbewahrung: einmal eingesammelt, antwortet der Link nicht mehr',
    severity: {
      info: 'Information',
      warning: 'Warnung',
      error: 'Fehler',
      critical: 'Kritisch'
    },
    category: {
      lifecycle: 'Lebenszyklus',
      config: 'Konfiguration',
      availability: 'Verfügbarkeit',
      security: 'Sicherheit'
    },
    type: {
      haNetsvcFailedOver: 'Failover des Netzwerkdienstes',
      haNetsvcNoCandidate: 'Netzwerkdienst ohne Kandidaten-Knoten',
      haNetsvcReaped: 'Lokale Instanz beim Wiedereintritt gemäht',
      netsvcFloatipMoved: 'Floating IP zu einem anderen Halter gewandert',
      netsvcFloatipNoHolder: 'Floating IP ohne gesundes Ziel',
      haAppFailedOver: 'Failover der App-Instanz',
      haAppNoCandidate: 'App-Instanz ohne Kandidaten-Knoten',
      haAppStorageLocalSkip: 'App-Instanz nicht übernommen: persistente Daten lokal auf dem toten Knoten',
      haAppReaped: 'Lokaler Pod der App-Instanz beim Wiedereintritt gemäht'
    }
  },
  audit: {
    loadError: 'Das Auditregister konnte nicht geladen werden — ist das TVirt-Backend erreichbar?',
    title: 'Audit',
    subtitle: 'Wer hat was wann an welchem Objekt getan — versuchte Handlungen, Ablehnungen eingeschlossen',
    filterOutcome: 'Ausgang',
    filterAll: 'Alle',
    filterSudo: 'Nur erhöhte Handlungen',
    colAt: 'Wann',
    colActor: 'Wer',
    colAction: 'Aktion',
    colTarget: 'Objekt',
    colOutcome: 'Ausgang',
    colNode: 'Node',
    empty: 'Keine Handlungen aufgezeichnet',
    loadMore: 'Mehr laden',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Route',
    detailProblem: 'Grund',
    detailTask: 'Task',
    detailClientIp: 'Von',
    detailId: 'Datensatz-ID',
    detailSession: 'Sitzung',
    taskHint: 'Der Ausgang einer angenommenen Handlung lebt im Ereignisjournal, unter derselben Task-ID',
    outcome: {
      succeeded: 'Erledigt',
      accepted: 'Angenommen',
      denied: 'Verweigert',
      rejected: 'Abgelehnt',
      failed: 'Fehlgeschlagen'
    }
  },
  notifications: {
    loadError: 'Die Benachrichtigungen konnten nicht geladen werden — ist das TVirt-Backend erreichbar?',
    actionError: 'Die Aktion wurde abgelehnt',
    title: 'Benachrichtigungen',
    subtitle: 'Die Ziele, zu denen die Fakten des Journals den Cluster verlassen',
    rulesTitle: 'Regeln',
    rulesSubtitle: 'Welche Fakten hinausgehen und wohin',
    deliveriesTitle: 'Zustellungen',
    deliveriesSubtitle: 'Das Ergebnis jeder Benachrichtigung, mit dem Warum bei einem Fehlschlag',
    colName: 'Name',
    colKind: 'Typ',
    colWhere: 'Wohin',
    colScope: 'Scope',
    colSeverity: 'Schweregrad',
    colMatch: 'Filter',
    colTargets: 'Ziel',
    colAt: 'Wann',
    colState: 'Status',
    colEvent: 'Ereignis',
    colAttempts: 'Versuche',
    colOutcome: 'Ergebnis',
    empty: 'Keine Zeile',
    matchAll: 'alle Fakten',
    test: 'Testen',
    testOk: 'Testbenachrichtigung an {target} zugestellt',
    testFailed: 'Test an {target} fehlgeschlagen: {reason}',
    retry: 'Erneut einreihen',
    retried: 'Zustellung erneut eingereiht',
    grouped: 'und {count} weitere Wiederholungen',
    state: {
      failed: 'Fehlgeschlagen',
      pending: 'In der Warteschlange',
      sending: 'Wird gesendet',
      sent: 'Gesendet'
    },
    tabTargets: 'Ziele',
    tabRules: 'Regeln',
    tabDeliveries: 'Zustellungen',
    targetCreateTitle: 'Neues Ziel',
    ruleCreateTitle: 'Neue Regel',
    nameHint: 'Kleinbuchstaben, Ziffern und Bindestriche; pro Scope eindeutig',
    kindImmutableHint: 'Unveränderlich: den Typ zu ändern heißt, ein anderes Ziel anzulegen',
    kindSmtp: 'E-Mail (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Status',
    enabledOn: 'Aktiv',
    enabledOff: 'Ausgesetzt',
    smtpHost: 'SMTP-Server',
    smtpPort: 'Port',
    smtpPortHint: 'Üblich: 25 ohne TLS, 587 mit starttls, 465 mit tls',
    smtpSecurity: 'Sicherheit',
    smtpFrom: 'Absender',
    smtpTo: 'Empfänger',
    smtpToHint: 'Eine oder mehrere Adressen, durch Komma getrennt',
    webhookUrl: 'URL',
    payload: 'Inhalt',
    payloadHint: 'Mit minimal verlassen Meldung und Daten des Ereignisses den Cluster nicht',
    credential: 'Zugangsdaten',
    credentialNone: 'Keine',
    credentialHintSmtp: 'Relay-Konto aus dem Keystore; keine bedeutet anonymes SMTP',
    credentialHintWebhook: 'Signaturgeheimnis aus dem Keystore; ohne Signatur kann sich jeder mit der URL als Cluster ausgeben',
    minSeverityHint: 'Eine Schwelle, keine Menge: ab diesem Schweregrad',
    categories: 'Kategorien',
    categoriesHint: 'Leer = alle',
    types: 'Ereignistypen',
    typesHint: 'Durch Komma getrennt; leer = alle. Ein unbekannter Typ wird abgelehnt',
    targetsHint: 'Mindestens eines; sie müssen im Scope der Regel oder einem seiner Vorfahren liegen',
    recursiveOn: 'Auch die Kind-Scopes',
    recursiveOff: 'Nur dieser Scope',
    recursiveHint: 'Ressourcen leben in den Blättern: ohne Kinder meldet eine Regel auf der Wurzel fast nichts',
    repeatWindow: 'Gruppierungsfenster (s)',
    repeatWindowHint: 'Innerhalb des Fensters senden Wiederholungen keine Mail: sie werden bei der ersten gezählt. 0 schaltet ab',
    targetInUseError: 'Ziel {name} wird noch von einer Regel benutzt'
  }
}
